import Vue from "vue";
import apiCall from "@/utils/api";
import {
    AUTH_REQUEST,
    AUTH_REFRESH,
    AUTH_REFRESH_PERFORM,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT,
    PERMISSIONS_REQUEST
  } from "../actions/auth";
import { USER_REQUEST_PROMISE } from "../actions/user";

const state = {
    uid: localStorage.getItem("uid") || "",
    roles: (localStorage.getItem("roles") || "").split(",").map(Number),
    accessToken: localStorage.getItem("tkn") || "",
    refreshToken: localStorage.getItem("rtkn") || "",
    status: ""
};

const getters = {
    isAuthenticated: state => !!state.accessToken,
    authId: state => parseInt(state.uid),
    authStatus: state => state.status,
    authRoles: state => state.roles,
};

const actions = {
    [AUTH_REQUEST]: ({ commit /*, dispatch*/ }, login_data) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST);
        apiCall({ url: "auth", data: login_data, method: "POST" })
          .then(resp => {
            if (!resp.access_token) {
              commit(AUTH_ERROR, resp);
              localStorage.removeItem("tkn");
              reject(resp);
              return;
            }
            localStorage.setItem("tkn", resp.access_token);
            localStorage.setItem("rtkn", resp.refresh_token);
            localStorage.setItem("uid", resp.uid);
            localStorage.setItem("roles", resp.roles.join(","));
            // + помечаем последнее время обновления токена
            localStorage.setItem("tkn_refreshed_dt", Date.now());
            commit(AUTH_SUCCESS, resp);
            //dispatch(USER_REQUEST);
            resolve(resp);
          })
          .catch(err => {
            commit(AUTH_ERROR, err);
            localStorage.removeItem("tkn");
            reject(err);
          });
      });
    },
    [AUTH_REFRESH]: ({ dispatch }) => {
      let lastRefresh = parseInt(localStorage.getItem("tkn_refreshed_dt") ?? "0");
      let needRefresh = !lastRefresh || Date.now() - lastRefresh > 1000 * 60 * 60 * 1;

      // temporary
      let tkn = localStorage.getItem("tkn");
      let rtkn = localStorage.getItem("rtkn");
      if (tkn && !rtkn) {
        localStorage.setItem("rtkn", tkn);
      }
      // end temporary

      if (needRefresh) {
        dispatch(AUTH_REFRESH_PERFORM);
        return
      }
      dispatch(USER_REQUEST_PROMISE).catch(() => {
        needRefresh = true
        dispatch(AUTH_REFRESH_PERFORM);
      })
    },
    [AUTH_REFRESH_PERFORM]: ({ dispatch }) => {
      const refreshToken = localStorage.getItem("rtkn");
      
      if (!refreshToken) {
        dispatch(AUTH_LOGOUT);
        return;
      }

      apiCall({ url: "auth/token/refresh", data: {
        refresh_token: refreshToken
      }, method: "POST" })
        .then(resp => {
          if (!resp.access_token) {
            dispatch(AUTH_LOGOUT);
            return;
          }
          localStorage.setItem("tkn", resp.access_token);
          localStorage.setItem("rtkn", resp.refresh_token);
          localStorage.setItem("uid", resp.uid);
          localStorage.setItem("roles", resp.roles.join(","));
          // + помечаем последнее время обновления токена
          localStorage.setItem("tkn_refreshed_dt", Date.now());
          window.location.reload();
        })
        .catch(() => {
          dispatch(AUTH_LOGOUT);
        });
    },
    [AUTH_LOGOUT]: ({ commit }) => {
      return new Promise(resolve => {
        const uidBefore = state.uid
        commit(AUTH_LOGOUT);
        localStorage.removeItem("uid");
        localStorage.removeItem("tkn");
        localStorage.removeItem("rtkn");
        localStorage.removeItem("roles");
        resolve();
        if (uidBefore) {
          window.location.reload();
        }
      });
    },
    [PERMISSIONS_REQUEST]: ({ commit, state }) => {      
      apiCall({ url: "user/permissions/" + state.uid })
        .then(resp => {
          localStorage.setItem("roles", resp.join(","));
          commit(PERMISSIONS_REQUEST, resp);
        })
    }
};

const mutations = {
    [AUTH_REQUEST]: state => {
      state.status = "loading";
    },
    [AUTH_SUCCESS]: (state, resp) => {
      state.status = "success";
      state.uid = resp.uid;
      state.accessToken = resp.access_token;
      state.refreshToken = resp.refresh_token;
      state.roles = resp.roles
    },
    [AUTH_ERROR]: state => {
      state.status = "error";
    },
    [AUTH_LOGOUT]: state => {
      state.uid = "";
      state.accessToken = "";
      state.refreshToken = "";
      state.roles = [];
    },
    [PERMISSIONS_REQUEST]: (state, resp) => {
      Vue.set(state, "roles", resp);
    },
  };
  
  export default {
    state,
    getters,
    actions,
    mutations
  };
  